<template>
  <div id="instProductSelector">
    <button
      type="button"
      :class="{active: selectedProduct === 'base'}"
      v-on:click="select('base')"
    >Обычный заём</button>
    <button
      type="button"
      :class="{active: selectedProduct === 'creditLine'}"
      v-on:click="select('creditLine')"
    >Кредитная линия</button>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instProductSelector",
  computed: {
    ...mapState({
      selectedProduct: state => state.Deal.selectedProduct,
    }),
  },
  methods: {
    select(value) {
      if (this.selectedProduct === value) return;
      this.$store.commit('setSelectedProduct', value);
    }
  }
}
</script>

<style scoped>
#instProductSelector{display: flex;background: white;border-radius: var(--font-size-10);padding: var(--font-size-04);margin-bottom: var(--font-size-20);font-family: 'Roboto';}
#instProductSelector button{flex: 1;border:0;background: transparent;padding: var(--font-size-10) var(--font-size-04);border-radius: var(--font-size-08);font-size: var(--font-size-14);font-weight: 500;color:var(--color-gray-type3);cursor: pointer;transition: background .2s, color .2s;}
#instProductSelector button.active{background: var(--color-green);color:white;}
</style>
